import { useRef, useEffect, useState } from "react";
import { getAreapCook } from "../../../../utils/params";
import Cookies from "universal-cookie";
import { socketon } from "../../../../utils/socket";
import { beep } from "../../../../utils/beeps";
import Toasts from "../../../toast";
import PropTypes from 'prop-types';

function Left({celdas,celdaheight}) 
 {
   const [Modulos, setModulos] = useState([]);
   const [opciones, setOpciones] = useState([]);
   const [showToast, setShowToast] = useState(false);
   const [turnos, setTurnos] = useState([]);
   const [selectedVoice, setSelectedVoice] = useState(null);
   const [pitch, setPitch] = useState(1.2);
   const [volume, setVolume] = useState(1);
   const [rate, setRate] = useState(0.8);
   const [turnoActual, setTurnoActual] = useState(null);
   const [ultimosTurnos, setUltimosTurnos] = useState([]);
   const [animar, setAnimar] = useState(false);

   let cookies = new Cookies();
   const cambiaturno = useRef(null);
     
  //-----------------------------------------------------
  const ActualizarModulo = () => 
    {
       let AreaId = getAreapCook();
       socketon.on("ActualizaTurnoMed", (message, sender) => 
        {
           if (message) 
            {
               if (message[0].AreaId.toString() === AreaId)
                 {
                  setAnimar(false);
                  const anterior = cambiaturno.current;
                  if (anterior) {
                     const esMismoTurno =
                       anterior.Prefijo === message[0].Prefijo &&
                       anterior.Consecutivo === message[0].Consecutivo
                     if (!esMismoTurno) {
                        setUltimosTurnos((prev) => {
                             const nuevos = [anterior, ...prev];
                              return nuevos.slice(0, 8); // máximo 8
                          });
                      }
                  }                
                  setTurnoActual(message[0]);
                  cambiaturno.current = message[0];
                  
                    beep();
                    InicioBienvenida(message[0].Prefijo, message[0].Consecutivo,message[0].CodConsult)
                    setAnimar(true);
                    setTimeout(() => setAnimar(false), 20000);
                 }  
            }
        });
    };

  //-----------------------------------------------------
  const InicioBienvenida = (Prefijo, Consecutivo, Modulo) =>
    {
     const Turno = SepararTextos(Prefijo ??'');
     const Module = SepararTextos(Modulo ??'');
     playVoice("Turno  " + Turno+ Consecutivo +"Módulo "+ Module );
    }
  
  //-----------------------------------------------------
  const playVoice = text =>
    {
       const synth = window.speechSynthesis;
       setSelectedVoice(cookies.get('Ctrvoice'));
   
       const vocey=cookies.get('Ctrvoice')
       if (vocey)
         {
           // getVoice(vocey.name, synth)
           // .then(voice => {
           const utterThis = new SpeechSynthesisUtterance(text);
           utterThis.voice = vocey.name;
           utterThis.pitch = pitch;
           utterThis.volume = volume;
           utterThis.rate = rate;
           synth.speak(utterThis);
           // })
           // .catch(error => alert("error: " + error));
         }
    };

 //------------------------------------------------------ 
 function getVoice(voiceName, synth) 
   {
      return new Promise((resolve, reject) => 
        {
          const loadVoices = () => 
            {
              const voices = synth.getVoices();
              const selectedVoice = voices.find(voice => voice.name === voiceName);

              if (selectedVoice) 
                {
                  resolve(selectedVoice);
                } 
              else 
                {
                  reject("No se encontró la voz: " + voiceName);
                }
            };

          // Las voces pueden no estar disponibles inmediatamente
          if (synth.getVoices().length !== 0) 
            {
               loadVoices();
             } 
          else 
           {
              synth.onvoiceschanged = loadVoices;
           }
        }); 
   }

 //------------------------------------------------------
 const SepararTextos = (Dato) => 
   {
      if (!Dato || typeof Dato !== 'string') return '';
        return Dato.split('').join(' ') + ' ';
    }

 //------------------------------------------------------
  useEffect(() => 
    {
      beep();
      setPitch(cookies.get('Ctrpitch')||1.2);
      setVolume(cookies.get('Ctrvolume'|| 1));
      setRate(cookies.get('Ctrrate'||0.8));
      setSelectedVoice(cookies.get('Ctrvoice'));
      ActualizarModulo();
      return () => 
        {
           return () => 
            {
               socketon.on("disconnect", () => {    });
            };
        };
    }, []);
  
  //-----------------------------------------------------
  useEffect(() => 
    {
       setTurnos(Array(Number(celdas)).fill(null));
    }, [celdas]);

  return (
    <>
    <div className="flex w-full flex-col m-4">
        <div className="flex flex-row w-full h-[6rem] bg-light">
           <div className="flex w-1/2 h-full text-center items-center justify-center">
             <span className="text-[2.5rem] 2xl:text-[2.9rem] font-bold text-gray-800 text-center">Consultorio</span>
           </div>
           <div className="flex w-1/2 h-full text-center items-center justify-center">
             <span className="text-[2.5rem] 2xl:text-[2.8rem] font-bold text-gray-800 text-center">Turno</span>
           </div>
        </div>
        
        {turnoActual && (
            <div className={`flex flex-col w-full bg-default h-[8rem] ${animar ? "ping-visible borde-parpadeante" : ""} transition`} >
               <div className="flex flex-row w-full h-[6rem]">
                   <div className="flex w-1/2 text-center items-center justify-center">
                     <span className="text-[4.7rem] font-poppins font-semibold text-white text-center">{turnoActual.CodConsult}</span>
                   </div>
                   <div className="flex w-1/2 text-center items-center justify-center">
                     <span className="text-[4.7rem] font-poppins font-semibold text-white text-center">{turnoActual.Prefijo}{turnoActual.Consecutivo}</span>
                   </div>
               </div>
               <div className="flex w-full h-[2rem] text-center items-center justify-center  bg-white ">
                  <span className="text-[2.1rem] font-poppins font-semibold text-default text-center">{turnoActual.NombreBen}</span>
               </div>
            </div>)}
        <div className="flex flex-row mt-4 w-full min-h-[75%] bg-[#d1d5dc] ">
          <ul className="flex flex-col w-full h-full space-y-1 text-[2.1rem]">
             {ultimosTurnos.map((item, idx) => (
              <li key={idx} className="flex flex-row w-full text-gray-700 text-[3.5rem] font-medium ">
                <div className="flex flex-row w-full h-[6rem]">
                   <div className="flex w-1/2 text-center items-center justify-center">
                     <span className="text-[4.7rem] font-poppins font-semibold text-gray-700 text-center">{item.CodConsult}</span>
                   </div>
                   <div className="flex w-1/2 text-center items-center justify-center">
                     <span className="text-[4.7rem] font-poppins font-semibold text-gray-700 text-center">{item.Prefijo}{item.Consecutivo}</span>
                   </div>
               </div>
              </li>
            ))}
          </ul>
        </div>
    </div>
  {showToast && 
    (
      <Toasts
        type={opciones.type}
        message={opciones.message}
        active={opciones.active}
      ></Toasts>
    ) 
  }
  </>
  );
  
}
Left.propTypes = {
      celdas: PropTypes.number.isRequired,
      celdaheight: PropTypes.number.isRequired,
      //voce: PropTypes.object.isRequired
    };

export default Left;
